export default __webpack_public_path__ + "447b6f7a689a08368a9b95c1386da182.woff2";